export default __webpack_public_path__ + "static/media/clock_icon.b1554990.svg";